// extracted by mini-css-extract-plugin
export default {"container":"QNG1hiAR","title":"mQj7WXsw","checkbox-wrapper":"RwqWzRUP","error":"IS2zEivU","button":"rgPJr4Qn","preloader":"qP7tayIW"};